import React from "react";

const Footer = () => {
  return (
    <footer className="bg-containx-charcoal text-white py-2 h-24">
      <div className="max-w-6xl mx-auto h-full flex items-center justify-center">
        <p className="text-sm">© 2025 CONTAINX, INC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
